import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import googlePresentationLogo from './googlePresentationLogo.png';
import GoogleSmartMenu from '../SmartMenu/GoogleSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const GooglePresentationLink = ({ children, ...restProps }: Props) => (
  <SmartLinkContainer contentEditable={false}>
    <GoogleSmartMenu type="presentation" logoName={googlePresentationLogo} {...restProps}>
      <SmartLink {...restProps}>
        <SmartLinkLogo src={googlePresentationLogo} />
        {children}
      </SmartLink>
    </GoogleSmartMenu>
  </SmartLinkContainer>
);

export default GooglePresentationLink;
